import React from 'react';
import styled from 'styled-components';
import { ContactInput } from '../../shared/component/headless/input/InputBody';
import OrgInputAnchorVisi from '../../shared/component/organism/OrgInputAnchorVisi';
import OrgInputDivVisi from '../../shared/component/organism/OrgInputDivVisi';
import { getContactsMessage } from '../../shared/constants/pageMessages';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import confirmIcon from '../../asset/icon/confirm2.png';
import confirmIcon2 from '../../asset/icon/confirm3.png';
import { useContactPage } from '../../shared/hooks/page/useContactPage';

const ContactFold: React.FC = () => {
  const {
    canShow,
    contact,
    contactPropertyVisible,
    isEditMode,
    hasChanged,
    handleChange,
    handleSnsChange,
    handleDoubleClick,
    changeVisibleMobile,
    handleConfirm,
    igValue,
    twValue,
    fbValue,
    url1Value,
  } = useContactPage();

  if (!canShow || !contact || !contactPropertyVisible) {
    return null;
  }

  return (
    <ContactContainer>
      <ContactTitle>Contact</ContactTitle>
      <Contact1Container>
        <Contact_1>
          <OrgInputDivVisi
            value={contact.address}
            defaultValue={getContactsMessage('CONTACT_DEFAULT_ADDRESS')}
            placeholder={getContactsMessage('CONTACT_PLACEHOLDER_ADDRESS')}
            handleChange={(e) => handleChange({ address: e.target.value })}
            inputStyle={ContactInput}
            StyledDiv={ContactDiv}
            DefaultDiv={DefaultDiv}
            visible={contactPropertyVisible.address}
            changeVisible={() => handleDoubleClick('address')}
            changeVisibleMobile={() => changeVisibleMobile('address')}
          />
        </Contact_1>
        <Contact_1>
          <OrgInputDivVisi
            value={contact.email}
            defaultValue={getContactsMessage('CONTACT_DEFAULT_EMAIL')}
            placeholder={getContactsMessage('CONTACT_PLACEHOLDER_EMAIL')}
            handleChange={(e) => handleChange({ email: e.target.value })}
            inputStyle={ContactInput}
            StyledDiv={ContactDiv}
            DefaultDiv={DefaultDiv}
            visible={contactPropertyVisible.email}
            changeVisible={() => handleDoubleClick('email')}
            changeVisibleMobile={() => changeVisibleMobile('email')}
          />
          <OrgInputDivVisi
            value={contact.contact}
            defaultValue={getContactsMessage('CONTACT_DEFAULT_CONTACT')}
            placeholder={getContactsMessage('CONTACT_PLACEHOLDER_CONTACT')}
            handleChange={(e) => handleChange({ contact: e.target.value })}
            inputStyle={ContactInput}
            StyledDiv={ContactDiv}
            DefaultDiv={DefaultDiv}
            visible={contactPropertyVisible.contact}
            changeVisible={() => handleDoubleClick('contact')}
            changeVisibleMobile={() => changeVisibleMobile('contact')}
          />
        </Contact_1>
        <Contact_1>
          <OrgInputAnchorVisi
            value={igValue ? `@${igValue}` : ""}
            defaultValueKey="CONTACT_DEFAULT_INSTAGRAM"
            placeholder={getContactsMessage('CONTACT_PLACEHOLDER_INSTAGRAM')}
            handleChange={(e) => handleSnsChange({ instagram: e.target.value })}
            inputStyle={ContactInput}
            StyledDiv={ContactAnchor}
            visible={contactPropertyVisible.instagram}
            changeVisible={() => handleDoubleClick('instagram')}
            changeVisibleMobile={() => changeVisibleMobile('instagram')}
          />
          <OrgInputAnchorVisi
            value={twValue}
            defaultValueKey="CONTACT_DEFAULT_TWITTER"
            placeholder={getContactsMessage('CONTACT_PLACEHOLDER_TWITTER')}
            handleChange={(e) => handleSnsChange({ twitter: e.target.value })}
            inputStyle={ContactInput}
            StyledDiv={ContactAnchor}
            visible={contactPropertyVisible.twitter}
            changeVisible={() => handleDoubleClick('twitter')}
            changeVisibleMobile={() => changeVisibleMobile('twitter')}
          />
          <OrgInputAnchorVisi
            value={fbValue}
            defaultValueKey="CONTACT_DEFAULT_FACEBOOK"
            placeholder={getContactsMessage('CONTACT_PLACEHOLDER_FACEBOOK')}
            handleChange={(e) => handleSnsChange({ facebook: e.target.value })}
            inputStyle={ContactInput}
            StyledDiv={ContactAnchor}
            visible={contactPropertyVisible.facebook}
            changeVisible={() => handleDoubleClick('facebook')}
            changeVisibleMobile={() => changeVisibleMobile('facebook')}
          />
          <OrgInputAnchorVisi
            value={url1Value}
            defaultValueKey="CONTACT_DEFAULT_URL1"
            placeholder={getContactsMessage('CONTACT_PLACEHOLDER_URL1')}
            handleChange={(e) => handleSnsChange({ url1: e.target.value })}
            inputStyle={ContactInput}
            StyledDiv={ContactAnchor}
            visible={contactPropertyVisible.url1}
            changeVisible={() => handleDoubleClick('url1')}
            changeVisibleMobile={() => changeVisibleMobile('url1')}
          />
        </Contact_1>
      </Contact1Container>

      {isEditMode && (
        <SettingNotice>
          * {getContactsMessage('CONTACT_MENU_VISIBILITY_HINT')}
        </SettingNotice>
      )}

      {isEditMode && hasChanged && (
        <BtnContainer>
          <UniversalIconBtn
            isPrimary={true}
            size="fit"
            border={false}
            backgroundImg={confirmIcon}
            backgroundImgHover={confirmIcon2}
            onClick={handleConfirm}
          />
        </BtnContainer>
      )}
    </ContactContainer>
  );
};


const ContactContainer = styled.section`
  position: relative;
  width: clamp(300px, 50%, 500px);
  display: flex;
  flex-direction: column;

  margin-top: 50px;
`;

const Contact1Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 10px;
`;

const Contact_1 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DefaultDiv = styled.div`
  width: 100%;
  height: 16px;
  color: ${({ theme }) => theme.colors.color_Gray_05} !important;
  ${({ theme }) => theme.typography.Body_04};

  background-color: ${({ theme }) => theme.colors.color_Gray_06};
`;

const ContactTitle = styled.div`
  width: fit-content;
  border-bottom: 1.6px solid ${({ theme }) => theme.colors.color_Gray_02};

  padding: 8px 0px;
  padding-right: 6px;
  margin-bottom: 12px;
  ${({ theme }) => theme.typography.Body_02_1};
`;

const ContactDiv = styled.div`
  width: 100%;
  height: 16px;

  display: flex;
  align-items: center;
  gap: 10px;

  color: ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_04};
`

const ContactAnchor = styled.div`
  position: relative;
  width: fit-content;
  min-width: 100px;
  height: 16px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: clamp(4px, 0.4vw, 8px);
  text-decoration: underline;

  color: ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_04};
  cursor: pointer;
`

const SettingNotice = styled.div`
  width: 100%;
  display: flex;

  align-items: end;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Footer_01};
`;

const BtnContainer = styled.div`
  position: absolute;
  right: 2px;
  bottom: -6vh;
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5vw;
`;

export default ContactFold;
